import {  CUSTOM_PARTNER } from 'common/config';
import { encryptRSA } from './rsaEncrypter';
import { getPartnerId } from './getPartnerId';
import { setCookie } from './saveToCookies';
import axios from 'axios';


export const refreshPartnerToken = async (baseURL) => {
  try {
    const partnerId = await encryptRSA(getPartnerId);

    const header = {
      headers: {
        Authorization: partnerId,
        'go-auth': 'true'
      },
    };

    const url = CUSTOM_PARTNER + '/token';

    const axiosRefresh = axios.create({
      baseURL: baseURL,
      timeout: 90000,
    });

    const res = await axiosRefresh.get(url, header);

    if (res.data.partnerToken) {
      setCookie('PARTNER_TOKEN', res.data.partnerToken, 10);
      return res.data.partnerToken;
    }

  } catch (err) {
    //err
  }
};